export default __webpack_public_path__ + "static/media/location-maker.8cfb5acb.svg";